import React, { memo, useMemo } from 'react';
import { campSlice } from '../../../store/reducers/campReducer';
import { useAppDispatch, useAppSelector } from '../../../store/store';
import CampAlliesListItem from './CampAlliesListItem';

interface ICampAlliesListProps {
    openInfo: () => void
    isInfo: boolean
}

const CampAlliesList = ({ isInfo, openInfo }: ICampAlliesListProps) => {
    const alliesArr = useAppSelector(state => state.campReducer.allies)
    const { setAllyActiveIndex } = campSlice.actions
    const dispatch = useAppDispatch()

    function handleClick(index: number) {
        openInfo()
        dispatch(setAllyActiveIndex(index))
    }

    return (
        <ul className="camp-allies__list">
            {alliesArr.map((ally, i) => {
                return (
                    <CampAlliesListItem
                        key={crypto.randomUUID()}
                        ally={ally}
                        handleClick={() => handleClick(i)}
                        index={i}
                        isInfo={isInfo} />
                )
            })}
        </ul>
    );
};

export default memo(CampAlliesList);